import { Button, Checkbox, Collapse, Divider, Grid, Paper, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import debounce from 'lodash.debounce';
import React, { useCallback, useState } from 'react'
import { actualizarEmpleadosProyectos } from '../../../services/apis';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { ordenarPorCampoTexto } from '../../../utils/utils';
// Componentes estilizados
const StickyTableCell = styled(TableCell)(({ theme }) => ({
    position: 'sticky',
    left: 0,
    backgroundColor: '#e53935',
    zIndex: 1,
}));

const StickyHeaderCell = styled(StickyTableCell)(({ theme }) => ({
    backgroundColor: '#e53935',
    zIndex: 2,
    width: '15em'
    // borderTop: '2px solid',
    // borderColor: '#e53935',
}));
export const EmpleadosProyectos = ({ empleados, setEmpleadosProyectos, opciones, title, nombreArray, descripcion, index }) => {

    // Estado local para opciones con roles_permitidos
    const [opcionesTempOG, setOpcionesTempOG] = useState([...opciones]);
    const [accesos, setAccesos] = useState([...opciones]);
    const [open, setOpen] = useState(null);
    const [proyectos, setProyectos] = useState([...opciones])
    const textoMayusculas = (texto) => String(texto || '').toUpperCase();

    // Función para manejar el cambio en los permisos
    const handleCheckboxChange = (idEmpleado, idProyecto) => {

        const updateEmpleados = empleados.map((empleado) => {
            if (empleado.id === idEmpleado) {
                const idPyPresent = empleado.proyectos_permitidos.includes(idProyecto);

                const updateEmpleado = idPyPresent
                    ? empleado.proyectos_permitidos.filter((id) => id !== idProyecto)
                    : [...empleado.proyectos_permitidos, idProyecto];

                let temp = { ...empleado, proyectos_permitidos: updateEmpleado }
                actualizarAccesos(temp)
                return temp;
            }
            return empleado;
        })

        setEmpleadosProyectos(updateEmpleados)
    };

    const actualizarAccesos = async (empleado) => {
        console.log('empleado', empleado);

        try {
            const response = await actualizarEmpleadosProyectos(empleado);

            console.log(response);


        } catch (error) {
            console.error('Error al cargar las opciones:', error);
        }
    }

    const buscarOpcion = (event) => {
        console.log("Buscando opción:", event.target.value.toLowerCase());

        const searchTerm = event.target.value.toLowerCase();

        if (searchTerm === "") {
            // Si el campo de búsqueda está vacío, puedes restaurar la lista original
            // Por ejemplo:
            setAccesos(opcionesTempOG);
            setProyectos(opcionesTempOG);
            return;
        }

        const resultados = opcionesTempOG.filter(opcion => {
            return (
                opcion.nombre.toLowerCase().includes(searchTerm)
            );
        });

        const resultados2 = opciones.filter(opcion => {
            return (
                opcion.nombre.toLowerCase().includes(searchTerm)
            );
        });

        setProyectos(resultados2);
        // Actualiza el estado con los resultados
        // Por ejemplo:
        setAccesos(resultados2);
        console.log("Resultados de búsqueda:", resultados);
    }


    return (
        <>
            {opciones && opciones.length >= 1 && (
                <Grid container direction={'row'} alignItems={'center'} justifyContent={'center'} xs={12}>
                    <Grid container direction={'column'} alignItems={'start'} justifyContent={'start'} xs={10}>
                        <Typography variant='h4' sx={{ mt: 4, textAlign: 'left' }}>
                            <Button variant='text' onClick={() => (index != open ? setOpen(index) : setOpen(null))}>
                                {
                                    index != open
                                        ? <VisibilityIcon sx={{ fontSize: 35, mt: -0.5 }} />
                                        : <VisibilityOffIcon sx={{ fontSize: 35, mt: -0.5 }} />
                                }
                            </Button>
                            EMPLEADOS PROYECTOS
                        </Typography>
                        <Typography variant='body2' sx={{ mb: 3, mt: 1, textAlign: 'left' }}>
                            Empleados asignables en proyectos
                        </Typography>

                    </Grid>
                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        xs={11.5} sm={11} md={10}
                    >
                        <Collapse in={open === index} fullWidth sx={{ overflow: 'auto', minWidth: '100%' }}>
                            <Grid container direction={'column'} alignItems={'center'} justifyContent={'center'} xs={12}>
                                {
                                    opcionesTempOG.length > 10
                                        ? <Grid container xs={12} sx={{ mb: 2 }}>
                                            <TextField id="standard-basic" label="Buscar..." variant="standard" size="small" name='search' fullWidth onChange={(event) => buscarOpcion(event)} />
                                        </Grid>
                                        : <></>
                                }

                                <TableContainer component={Paper} sx={{ minWidth: "100%"}}>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow sx={{ backgroundColor: '#e53935' }}>
                                                <StickyHeaderCell style={{ borderRight: '1px solid', borderRightColor: '#e0e0e0' }}>
                                                    <Typography variant='h6' sx={{ fontSize: 25, color: 'white' }}>
                                                        EMPLEADOS
                                                    </Typography>
                                                </StickyHeaderCell>
                                                {ordenarPorCampoTexto(proyectos, 'nombre').map((proyecto) => (
                                                    <TableCell key={proyecto.id} align="center">
                                                        <Typography variant='h6' sx={{ fontSize: 15, color: 'white' }}>
                                                            {textoMayusculas(proyecto.nombre)}
                                                        </Typography>
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody sx={{ maxHeight: '10vh', overflow: 'auto' }}>
                                            {ordenarPorCampoTexto(empleados, 'nombre').map((empleado, indexEmp) => (
                                                <TableRow key={empleado.id} sx={{ backgroundColor: indexEmp % 2 === 0 ? '#ffffff' : '#f7e2e1' }}>
                                                    <StickyHeaderCell>
                                                        <Typography variant='h6' sx={{ fontSize: 20, color: 'white' }}>
                                                            {textoMayusculas(empleado.nombre)}
                                                        </Typography>
                                                    </StickyHeaderCell>
                                                    {ordenarPorCampoTexto(accesos, 'nombre').map((acceso) => (
                                                        <TableCell key={`${empleado.id}-${acceso.id}`} align="center">
                                                            <Checkbox
                                                                checked={empleado.proyectos_permitidos.includes(parseInt(acceso.id))} // Verificar si el rol está en roles_permitidos
                                                                onChange={() => handleCheckboxChange(parseInt(empleado.id), acceso.id)} // Manejar el clic
                                                            />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            ))}
                                        </TableBody>

                                    </Table>
                                </TableContainer>

                            </Grid>
                        </Collapse>
                    </Grid>

                    <Grid item xs={10}>
                        <Divider sx={{ minWidth: '100%', display: index === open ? 'none' : 'flex', transition: 'all ease 0.25s' }}></Divider>
                    </Grid>
                </Grid>
            )}
        </>
    )
}
